import config from "@/config"
import http from "@/utils/request"

export default {
	listLanguage: {
		url: `${config.API_URL}/lqa-game/system/language/data/list`,
		name: "获取双语文件信息",
		get: async function (params) {
			return await http.get(this.url, params);
		}
	},
	getLanguage: {
		url: `${config.API_URL}/lqa-game/system/language/data/`,
		name: "获取双语文件信息",
		get: async function (params) {
			return await http.get(this.url + params);
		}
	},
	addLanguage: {
		url: `${config.API_URL}/lqa-game/system/language/data`,
		name: "获取双语文件信息",
		post: async function (data) {
			return await http.post(this.url, data);
		}
	},
	updateLanguage: {
		url: `${config.API_URL}/lqa-game/system/language/data`,
		name: "获取双语文件信息",
		put: async function (data) {
			return await http.put(this.url, data);
		}
	},
	delLanguage: {
		url: `${config.API_URL}/lqa-game/system/language/data/`,
		name: "删除双语文件信息",
		delete: async function (id) {
			return await http.delete(this.url + id);
		}
	},
	exportLanguage: {
		url: `${config.API_URL}/lqa-game/system/language/data/export?lang=`,
		name: "导出双语文件信息",
		get: async function (params, config={timeout:20000}) {
			return await http.get(this.url+params, config);
		}
	},
	importLanguage: {
		url: `${config.API_URL}/lqa-game//system/language/data/import`,
		name: "附件上传",
		post: async function (data, config = {}) {
			return await http.post(this.url, data, config);
		}
	},
	flushRedis:{
		url: `${config.API_URL}/lqa-game/system/language/data/flushRedis`,
		name: "刷新缓存",
		get: async function () {
			return await http.get(this.url);
		}
	},
}
